import { Clock, Mail, Phone } from 'lucide-react';
import { ContactDetails } from '@/constants/contact';
import { ContactDetailsCardContent } from '@/pages/Contact/data';

const ContactMethods = [
  { id: 'email', icon: Mail, label: ContactDetailsCardContent.emailLabel, value: ContactDetails.email, href: `mailto:${ContactDetails.email}` },
  { id: 'phone', icon: Phone, label: ContactDetailsCardContent.phoneLabel, value: ContactDetails.phone, href: ContactDetails.phoneHref },
  { id: 'hours', icon: Clock, label: ContactDetailsCardContent.hoursLabel, value: ContactDetails.hours, href: null },
];

export function ContactDetailsCard() {
  return (
    <div className="rounded-xl border border-grid bg-paper p-6 sm:p-8">
      <h2 className="text-xl font-bold text-graphite">{ContactDetailsCardContent.title}</h2>
      <ul className="mt-6 space-y-5">
        {ContactMethods.map((contactMethod) => {
          const MethodIcon = contactMethod.icon;
          return (
            <li key={contactMethod.id} className="flex gap-4">
              <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-pad text-graphite">
                <MethodIcon aria-hidden="true" className="size-5" />
              </span>
              <div className="min-w-0">
                <p className="text-sm text-steel">{contactMethod.label}</p>
                {contactMethod.href ? (
                  <a
                    href={contactMethod.href}
                    className="break-words rounded-sm font-semibold text-graphite underline decoration-grid decoration-2 underline-offset-4 transition-colors hover:decoration-graphite focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-graphite"
                  >
                    {contactMethod.value}
                  </a>
                ) : (
                  <p className="font-semibold text-graphite">{contactMethod.value}</p>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}